<template>
  <v-hover>
    <div
      slot-scope="{ hover }"
      color="white"
      style="border-style: dashed; border-width: 2px; border-color: grey !important;"
      :class="`elevation-${hover ? 3 : 0}`"
    >
      <v-flex xs12 d-flex>
        <v-card flat>
          <v-card-text>
            <v-input hide-details>
              <template slot="prepend">
                <v-select
                  style="width: 80px"
                  label="Erfüllt"
                  required
                  :items="currentTypes"
                  item-value="id"
                  v-model="inputtype"
                  return-object
                  solo
                  hide-details
                  :background-color="inputtype.color"
                >
                  <template slot="prepend">
                    <div style="background-color:red;"></div>
                  </template>

                  <template slot="item" slot-scope="item">{{ item.item.text }}</template>

                  <template slot="selection" slot-scope="item">{{ item.item.short }}</template>
                </v-select>
              </template>

              <template>
                <v-text-field
                  @keyup.native.enter="sendEvent(actions.primary.event, $event)"
                  class="pa-0"
                  name="item_quick_create"
                  v-model="inputtext"
                  :label="actions.primary.text"
                  hide-details
                  clearable
                  solo
                >
                  <template slot="append">
                    <v-btn
                      flat
                      icon
                      color="primary"
                      @click="sendEvent(actions.primary.event, $event)"
                    >OK</v-btn>
                  </template>
                </v-text-field>
              </template>

              <template v-if="actions.secondary">
                <v-btn
                  v-for="(action, action_idx) in actions.secondary"
                  :key="action_idx"
                  flat
                  icon
                  color="primary"
                  @click="sendEvent(action.event, $event)"
                >
                  <v-icon>{{ action.icon }}</v-icon>
                </v-btn>
              </template>
            </v-input>
          </v-card-text>
        </v-card>
      </v-flex>
    </div>
  </v-hover>
</template>

<script>
import { mapGetters } from "vuex";
import { api as confApi } from "@/store/modules/configuration";

// TODO: Macht es Sinn hier default actions zu haben???
export default {
  props: {
    actions: {
      type: Object,
      default() {
        return {
          primary: {
            text: "Create new Item",
            event: "itemcreate_quick"
          },
          secondary: [
            {
              text: "Create item with dialog",
              icon: "edit",
              event: "itemcreate_dialog"
            }
          ]
        };
      }
    }
  },
  data() {
    return {
      inputtext: "",
      inputtype: {}
    };
  },
  mounted() {
    this.inputtype = this.defaultType;
  },
  computed: {
    ...mapGetters(confApi.namespace, [confApi.getters.measure]),
    currentTypes() {
      return this.measure.data.types.filter(item => item.hidden != true);
    },
    defaultType() {
      const item = this.currentTypes.find(item => {
        return item.default === true;
      });
      return item || {};
    }
  },
  methods: {
    sendEvent(event, data) {
      let newdata = {
        text: this.inputtext,
        type: this.inputtype.id
      };
      console.log("Newdata", newdata, data);
      this.$emit(event, newdata);
      this.inputtext = "";
    }
  }
};
</script>

<style>
.v-input__prepend-outer {
  margin-top: 0px;
  margin-right: 0px;
}
</style>
